/* eslint semi:0 */
import { isMobile, isTablet, } from 'utils/ua'
import { queryString as qs, } from 'utils/window'
import socialButtonsConf from 'config/socialButtonsConfig'
import { reactionsList, } from 'application/pageDataObject'
import safeLocalStorage from 'providers/safeLocalStorageProvider'
import { getMockReactions, getClientVotes as getClientVotesMock, } from './mock/socialBarDataMock'


const FEATURE_FLAGS = {
  reactionsMock: qs.reactionsMock,
  reactionsCampaignMock: qs.reactionsCampaignMock,
  votesMock: qs.votesMock,
  reactionsNoCachedVotes: qs.reactionsNoCachedVotes,
}
const CLIENT_VOTES_KEY = 'CLIENT_VOTES_KEY'


function getVotesFromLocalStorage(){
  if (FEATURE_FLAGS.reactionsNoCachedVotes) {
    return {}
  }
  return safeLocalStorage.get(CLIENT_VOTES_KEY, {})
}

export function cacheVote({ postId, reactionId, }){
  const curr = safeLocalStorage.get(CLIENT_VOTES_KEY, {})
  curr[postId] = reactionId
  safeLocalStorage.set(CLIENT_VOTES_KEY, curr)
}

export function getReactions(){
  if (FEATURE_FLAGS.reactionsMock) {
    return getMockReactions({ doesIncludeCampaign: FEATURE_FLAGS.reactionsCampaignMock, })
  }
  return reactionsList
}

export function getShareButtons(){
  const { facebook, twitter, whatsapp, comments, } = socialButtonsConf
  const baseSocialButtons = [facebook, twitter, ]
  const getBaseSocialButtonsWithComments = () => [...baseSocialButtons, comments, ]
  switch (true) {
    case isTablet:
      return getBaseSocialButtonsWithComments()
    case isMobile:
      return [...baseSocialButtons, whatsapp, ]
    default:
      return getBaseSocialButtonsWithComments()
  }
}

export function getClientVotes(){
  if (FEATURE_FLAGS.votesMock) {
    return getClientVotesMock()
  }
  return getVotesFromLocalStorage()
}

export function setUserVote({ postId, reactionId, }){
  const currVotesData = getVotesFromLocalStorage()
  const newVotesData = { ...currVotesData, [postId]: reactionId, }
  safeLocalStorage.set(CLIENT_VOTES_KEY, newVotesData)
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/reactions/socialBarDataSource.js